export default "__VITE_ASSET__Bq4ZzkFg__"